var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonHandraise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_931_1973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#605DEC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_1973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4808 17.2632H49.4784C49.0152 17.0798 48.5228 16.9834 48.0413 16.9834C47.5738 16.9834 47.0968 17.0749 46.6477 17.2449L46.6022 17.2632C46.2557 17.4008 45.9306 17.5885 45.6419 17.827V16.7179C45.6419 15.0033 44.6863 13.8942 43.4668 13.4085C43.0087 13.2202 42.5135 13.1287 42.0277 13.1287C41.5438 13.1287 41.0514 13.2202 40.5882 13.4085C40.231 13.5506 39.894 13.7474 39.596 13.9999C39.4242 12.5833 38.544 11.6483 37.4532 11.2081C36.9923 11.0248 36.4972 10.9329 36.0114 10.9329C35.528 10.9329 35.0351 11.0248 34.5723 11.2078C33.4744 11.6527 32.5944 12.5924 32.4273 14.0221C32.1317 13.77 31.7946 13.573 31.437 13.4313H31.4323C30.9718 13.2477 30.4789 13.1515 29.9956 13.1515C29.5122 13.1515 29.017 13.243 28.5565 13.4313C27.3372 13.917 26.3814 15.0261 26.3814 16.736H26.3857L26.3879 34.1125L24.9696 31.6511L24.9442 31.6051C24.0093 29.9871 22.5105 29.4648 21.0986 29.6661C20.5692 29.744 20.0468 29.9276 19.5835 30.1979C19.1183 30.4641 18.701 30.8213 18.3711 31.2385C17.4911 32.3617 17.1953 33.9248 18.1308 35.5428L20.9494 40.4242L25.662 48.5236C27.6855 51.7505 30.612 53.726 33.7726 54.5789C36.3119 55.2618 39.0095 55.2159 41.512 54.5193C44.0193 53.8181 46.3454 52.4517 48.1329 50.5039C50.2807 48.1571 51.6555 44.9763 51.6555 41.0847L51.6554 20.5682C51.6554 18.8536 50.6998 17.7492 49.4809 17.2634L49.4808 17.2632ZM49.6591 41.0844C49.6591 44.4394 48.4927 47.1668 46.6683 49.1609C45.1401 50.829 43.1438 51.9983 40.9823 52.5985C38.8167 53.2035 36.4834 53.2401 34.286 52.6487C31.588 51.9245 29.0878 50.2333 27.3554 47.4788L22.6709 39.4247L19.8524 34.5433C19.3938 33.7505 19.5244 32.9986 19.9392 32.4714C20.1157 32.247 20.3381 32.0589 20.5831 31.9166C20.8285 31.7749 21.1036 31.6786 21.3763 31.6415H21.3785C22.045 31.5453 22.7627 31.8068 23.2232 32.6042L23.2556 32.6549L25.4968 36.5414L25.4943 36.5461C25.6686 36.8531 25.93 37.0775 26.2322 37.206H26.2393L26.237 37.2107C26.5375 37.3341 26.8834 37.3665 27.2156 37.2792C27.5616 37.1924 27.8506 36.9952 28.0567 36.729L28.0639 36.7201H28.0663C28.2633 36.4587 28.3802 36.1334 28.3802 35.7805H28.3755L28.3733 16.7359H28.378C28.378 15.9704 28.7836 15.4845 29.297 15.2781C29.5076 15.1913 29.7485 15.15 29.9958 15.15C30.2455 15.15 30.4862 15.1913 30.697 15.2734V15.2781C31.2104 15.4847 31.616 15.9704 31.616 16.7359V30.3218C31.616 30.6884 31.7648 31.0184 32.0055 31.2567L32.1113 31.353C32.3357 31.5365 32.6242 31.6463 32.9406 31.6463H33.0691C33.4198 31.6463 33.7498 31.5041 33.9906 31.2661L34.0111 31.2478C34.2449 31.0093 34.3937 30.6836 34.3937 30.3218V14.5222C34.3937 13.752 34.7969 13.2614 35.3127 13.0554C35.5258 12.9729 35.7666 12.9269 36.0116 12.9269C36.2594 12.9269 36.4997 12.9729 36.7128 13.0554C37.2262 13.2614 37.6318 13.752 37.6318 14.5222V30.3218C37.6318 30.6795 37.781 31.0142 38.0238 31.2567H38.0219C38.2557 31.4905 38.5898 31.6462 38.9546 31.6462H39.0827C39.445 31.6462 39.7797 31.4998 40.02 31.2567L40.1027 31.1699C40.2928 30.9403 40.4097 30.6429 40.4097 30.3218H40.4079L40.4056 16.7177H40.4098C40.4098 15.9475 40.8135 15.4618 41.3288 15.2552C41.5424 15.1684 41.7851 15.1224 42.0282 15.1224C42.2756 15.1224 42.5187 15.1684 42.7295 15.2552C43.2429 15.4617 43.6461 15.9475 43.6461 16.7177V30.3218C43.6461 30.6748 43.7924 31.0048 44.0309 31.2478L44.045 31.2614L44.0976 31.3118L44.1047 31.3164C44.3361 31.523 44.6407 31.6464 44.9731 31.6464H45.0994C45.4613 31.6464 45.7935 31.5 46.0367 31.2569C46.2727 31.0231 46.424 30.6932 46.424 30.322L46.4235 20.568C46.4235 19.8025 46.8267 19.3166 47.3403 19.1102L47.3769 19.0966C47.5788 19.0234 47.8077 18.9821 48.0415 18.9821C48.2894 18.9821 48.5319 19.0276 48.7427 19.1102C49.2562 19.3167 49.6595 19.8025 49.6595 20.568L49.6591 41.0844Z",
    fill: "#00140B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_931_1973",
    x: 0.5,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_931_1973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_931_1973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_1973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(14.5 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonHandraise);
export default __webpack_public_path__ + "static/media/Button_Handraise.052838dea60c4dd3ae9474fd092a1982.svg";
export { ForwardRef as ReactComponent };